module.exports = __webpack_public_path__ + "img/dz.99c681f2.png";